import React from "react";

const TIMELINE_DIRECTION_IN = "in";
const TIMELINE_DIRECTION_OUT = "out";
export type TimelineDirectionFilter = "" | typeof TIMELINE_DIRECTION_IN | typeof TIMELINE_DIRECTION_OUT;

type StoredTimelineFilter = {
  direction?: string;
  types?: string[];
};

function readStoredTimelineFilter(storageKey: string): StoredTimelineFilter | null {
  try {
    const raw = localStorage.getItem(storageKey);
    return raw ? JSON.parse(raw) as StoredTimelineFilter : null;
  } catch {
    return null;
  }
}

export function usePersonTimelineFilters(accountId?: string | null) {
  const storageKey = React.useMemo(
    () => `persons-detail-timeline-filter-${accountId || "default"}`,
    [accountId]
  );

  const [timelineDirectionFilter, setTimelineDirectionFilter] = React.useState<TimelineDirectionFilter>(() => {
    const stored = readStoredTimelineFilter(storageKey);
    const direction = stored?.direction;
    return direction === TIMELINE_DIRECTION_IN || direction === TIMELINE_DIRECTION_OUT || direction === "" ? direction : "";
  });

  const [timelineTypeFilter, setTimelineTypeFilter] = React.useState<Set<string>>(() => {
    const stored = readStoredTimelineFilter(storageKey);
    return Array.isArray(stored?.types) ? new Set<string>(stored.types) : new Set<string>();
  });

  React.useEffect(() => {
    try {
      localStorage.setItem(
        storageKey,
        JSON.stringify({ direction: timelineDirectionFilter, types: Array.from(timelineTypeFilter) })
      );
    } catch {
      // LocalStorage persistence is optional for this filter.
    }
  }, [storageKey, timelineDirectionFilter, timelineTypeFilter]);

  return {
    timelineDirectionFilter,
    setTimelineDirectionFilter,
    timelineTypeFilter,
    setTimelineTypeFilter
  };
}
